export const UPDATE_CONFIGURATION = 'UPDATE_CONFIGURATION'
export const SET_RETURNING_PART_REASONS = 'SET_RETURNING_PART_REASONS'
